import React from 'react'
import { Navigation } from '@griegconnect/krakentools-react-kraken-app'
import { withActiveTenant } from '@app/routes/WithActiveTenant'
import { withServices } from '@app/routes/withServices'
import { PATH_TENANT_BASE, Permissions, PERMISSIONS } from '@app/constants'
import { AccessDependencies } from '@app/Content'
import { requireAllGlobalPermissions } from '@app/lib/access'

const PATH = PATH_TENANT_BASE + '/settings'

const stanleyActive = (d: AccessDependencies) => d.portConfig.stanley

export const stanleyModuleNavs: Navigation.Item<AccessDependencies>[] = [
  {
    name: 'Stanley',
    path: PATH + '/stanley',
    page: React.createElement(withServices(withActiveTenant(React.lazy(() => import('./InstallationPage'))))),
    exact: true,
    menu: true,
    access: (d) =>
      stanleyActive(d) && requireAllGlobalPermissions(Permissions.all(PERMISSIONS.global_access_system))(d),
  },
]
